
import { ReactComponent as SubjectPropertyMarkerSVG } from "./SubjectPropertyMarker.svg";
import { ReactComponent as CompPropertyMarkerSVG } from "./CompPropertyMarker.svg";
import PlaceHolderImage from "./Placeholder.svg";
import { ReactComponent as GreenArrow } from "./greenArrow.svg";
import { ReactComponent as RedArrow } from "./redArrow.svg";

export { CompPropertyMarkerSVG, SubjectPropertyMarkerSVG, PlaceHolderImage, GreenArrow, RedArrow };